import React from 'react';
import SuccessModalSC from './success-modal.styled';
import { HeadingTwo /* BodyText, SmallText  */ } from '../typography';
import { ReactComponent as CheckCircle } from '../../assets/img/svg/check-circle.svg';
import InlineLoading from '../ui/inline-loading';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import dlt from '../../utils/default-lang';

const SuccessModal = ({ headlineText, children }) => {
  if (headlineText === '') {
    return (
      <SuccessModalSC>
        <div className="modal-loading-wrap">
          <InlineLoading />
        </div>
      </SuccessModalSC>
    );
  }
  return (
    <SuccessModalSC>
      <div className="success-icon-wrap">
        <CheckCircle />
      </div>
      <div className="top-text-wrap">
        <HeadingTwo className="bold green">
          <FormattedHTMLMessage id={headlineText} defaultMessage={dlt[`${headlineText}`]} />
        </HeadingTwo>
      </div>

      <div className="success-message-wrap">{children}</div>
    </SuccessModalSC>
  );
};

export default injectIntl(SuccessModal);
